import API from '~config/api';
import { ApiPromise, DataResponse, ErrorResponse } from '~globals/api';

import {
  OrderValidateParams,
  OrderValidateResponse,
  OrderCompanyId,
  OrderBase,
} from './types';

export const ORDER_ENPOINTS = {
  validateTrackingCodeOrder: '/api/v1/Track/ValidateTrackingCode',
  getCompanyIdByTrackingCode: (trackingCode: string): string =>
    `/api/v1/Track/${trackingCode}/GetCompanyId`,
  getOrderInfoByTrackingCode: (trackingCode: string): string =>
    `/api/v1/Track/${trackingCode}`,
  getEvidencesOrderPDFByTrackingCode: (trackingCode: string): string =>
    `/api/v1/Report/EvidenceItemPDF/${trackingCode}`,
};

export const validateTrackingCodeOrder = (
  data: OrderValidateParams,
): ApiPromise<DataResponse<OrderValidateResponse>, ErrorResponse> =>
  API.post<DataResponse<OrderValidateResponse>, ErrorResponse>(
    ORDER_ENPOINTS.validateTrackingCodeOrder,
    data,
  );

export const getCompanyIdByTrackingCode = (
  trackingCode: string,
): ApiPromise<DataResponse<OrderCompanyId>, ErrorResponse> =>
  API.get<DataResponse<OrderCompanyId>, ErrorResponse>(
    ORDER_ENPOINTS.getCompanyIdByTrackingCode(trackingCode),
  );

export const getOrderInfoByTrackingCode = (
  trackingCode: string,
): ApiPromise<DataResponse<OrderBase>, ErrorResponse> =>
  API.get<DataResponse<OrderBase>, ErrorResponse>(
    ORDER_ENPOINTS.getOrderInfoByTrackingCode(trackingCode),
  );

export const getEvidencesOrderPDFByTrackingCode = (
  trackingCode: string,
): ApiPromise<Blob, ErrorResponse> =>
  API.get<Blob, ErrorResponse>(
    ORDER_ENPOINTS.getEvidencesOrderPDFByTrackingCode(trackingCode),
    {},
    { responseType: 'blob', timeout: 120000 },
  );
